module.exports = __webpack_public_path__ + "static/media/field.99d74afe.svg";